import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-direction",
  templateUrl: "./med-icon-direction.component.html",
})
export class MedIconDirectionComponent extends SvgMixinComponent {}
